export default "__VITE_ASSET__DijlvCmk__"